import React from "react";
import { AxiosError } from "axios";
import { MakeRequest } from "../DataUtil";
import { Validator, sanitizeInput } from "../Validation/Validator";
import ValidationSummary from "../Validation/ValidationSummary";
import {
  getAllFormElements,
  showValidationErrors,
  resetValidationErrors,
} from "../Utilities";
import SmallSpinner from "../SmallSpinner";

interface Props {
  onToaster: any;
}

interface State {
  size: string;
  formErrors: any;
  isLoading: boolean;
}

class AddSizeForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      size: "",
      formErrors: [],
      isLoading: false,
    };
    this.handleSizeChange = this.handleSizeChange.bind(this);
    this.save = this.save.bind(this);
  }
  postData(data: any): void {
    //process results from ajax call
    const successCallback = (result: any): void => {
      if (result && result !== undefined) {
        //do logic
        if (result.Success === true) {
          this.props.onToaster({ success: true }, "Success: Size Value Added");

          //force a rerender of ItemsList
          //by updating the state of renderCount which is assigned as ItemsList key value
          this.setState({
            size: "",
            isLoading: false,
          });
        } else {
          this.props.onToaster({ error: true }, "Error: " + result.Message);
          this.setState({ isLoading: false });
        }
      }
    };
    //handle errors
    const errorCallback = (error: AxiosError): void => {
      if (error) {
        this.setState({ isLoading: false });
        this.setState({ isLoading: false }, () => {
          this.props.onToaster(
            { error: true },
            error.response ? error.message : "Unknown Error"
          );
        });
        if (
          error.response &&
          error.response.status &&
          error.response.status === 401
        ) {
        }
      }
    };
    MakeRequest({
      url: "Admin/AddSize",
      method: "post",
      data: { postData: data },
      successCallback,
      errorCallback,
    });
  }
  handleSizeChange = (e: any) => {
    let clean = sanitizeInput(e.target.value, e.target.type);
    this.setState({ size: clean.toUpperCase() });
  };
  handleBlurValidation = (e: any) => {
    let errors = Validator({ fields: e.target });
    if (errors.length === 0) {
      this.setState({ formErrors: [] }, () => {
        resetValidationErrors(e.target);
      });
    } else {
      this.setState({ formErrors: errors }, () => {
        showValidationErrors(this.state.formErrors);
      });
    }
  };
  handleFocus = (e: any) => {
    this.setState({ formErrors: [] }, () => {
      resetValidationErrors(e.target);
    });
  };
  save = async (e: any) => {
    e.preventDefault();
    this.setState({ isLoading: true });
    const size: string = this.state.size.trim();

    let form = document.getElementById("addSizeForm");
    let allFormElements = getAllFormElements({ element: form ? form : e });
    let errors = Validator({ fields: allFormElements });

    //do size format check
    ///\d{2} [xX] \d{2}/gm is 00 X 00
    let pattern = size.search(/\d{2} [xX] \d{2}/gm);
    if (pattern === -1) {
      let error = {
        fieldName: "size",
        message: "Size should follow this format e.g 40 X 40",
      };
      errors?.push(error);
    }

    if (errors.length === 0) {
      //update state
      let sizeData: any = {
        SizeValue: size,
      };
      this.setState({ formErrors: [] }, () => {
        resetValidationErrors(e.target);
        //save the data
        this.postData(sizeData);
      });
    } else {
      this.setState({ isLoading: false, formErrors: errors }, () => {
        showValidationErrors(this.state.formErrors);
      });
    }
  };
  componentDidMount(): void {}
  render() {
    return (
      <div className="col-md-6">
        <div className="card-form">
          <h5 className="card-title">New Size Value</h5>
          <hr />
          <div className="center">
            <SmallSpinner
              isLoading={this.state.isLoading}
              actionText="Loading"
            />
          </div>
          <ValidationSummary Errors={this.state.formErrors} />
          <form id="addSizeForm" onSubmit={this.save}>
            <div className="form-group">
              <label htmlFor="fullName" className="label-dark">
                Size
              </label>
              <input
                id="size"
                className="form-control border-input"
                type="text"
                value={this.state.size}
                onChange={this.handleSizeChange}
                onBlur={this.handleBlurValidation}
                onFocus={this.handleFocus}
                placeholder="Size e.g 40 X 40"
                data-required="true"
                data-validationname="Size"
                data-id="size"
              />
            </div>
            <div className="form-group">
              <button
                type="submit"
                className="btn btn-success btn-round"
                data-id="shippingButton"
              >
                Save Size Value
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default AddSizeForm;
